/* The native picker is the only source of truth. Never replace a customer-selected light color. */
(() => {
  if (customElements.get('tg-order-guide')) return;
  const requests = new Map();

  class TianguangOrderGuide extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.input = this.querySelector('input[name="properties[Color temperature request]"]');
      const cacheKey = `${this.dataset.productId}:${this.dataset.formId}`;
      if (this.input && requests.has(cacheKey)) this.input.value = requests.get(cacheKey);
      this.input?.addEventListener('input', () => requests.set(cacheKey, this.input.value), { signal });
      this.scope = document.getElementById(`shopify-section-${this.dataset.sectionId}`) || this.closest('section') || document;
      this.scope.addEventListener('change', () => this.refreshSelectedColor(), { signal });
      this.scope.addEventListener('variant:change', () => this.refreshSelectedColor(), { signal });
      this.scope.addEventListener('variant:update', () => this.refreshSelectedColor(), { signal });
      customElements.whenDefined('variant-picker').then(() => {
        if (!this.isConnected) return;
        this.refreshSelectedColor();
      });
    }

    disconnectedCallback() { this.controller?.abort(); }

    picker() {
      return [...this.scope.querySelectorAll('variant-picker')].find(picker =>
        picker.getAttribute('form-id') === this.dataset.formId || picker.dataset.productId === this.dataset.productId
      );
    }

    refreshSelectedColor() {
      const label = this.querySelector('[data-tg-selected-light]');
      const values = this.querySelector('template[data-tg-cct-options]');
      const picker = this.picker();
      if (!label || !values || !picker) return;
      const lookup = [...values.content.children];
      const controls = [...picker.querySelectorAll('input:checked, option:checked')];
      for (const control of controls) {
        const id = control.dataset.optionValueId || control.value;
        const match = lookup.find(value => value.dataset.optionId === id);
        if (match) {
          const selected = match.dataset.optionLabel;
          label.textContent = selected;
          const summary = this.querySelector('[data-tg-light-summary]');
          if (summary?.dataset.purchaseReview === 'true') return;
          const title = summary?.querySelector('[data-tg-light-title]');
          const copy = summary?.querySelector('[data-tg-light-copy]');
          const warm = ['warm light', 'warm white', 'warm white (3000k)', 'warm light 3000k', '3000k'].includes(selected.trim().toLowerCase());
          if (title && copy) {
            title.textContent = selected;
            copy.textContent = 'Your light color follows the selection above. For lighting-control upgrades, contact us for compatibility and a separate quote.';
          }
          break;
        }
      }
    }
  }
  customElements.define('tg-order-guide', TianguangOrderGuide);
})();
